import type { ResourceNote } from '@quromedical/models';
import { MarkdownRenderer } from '@quromedical/utils/ui';
import { getDisplayDateTime } from 'core/display';
import { renderers } from 'core/notes';
import { FormCard, type RowConfig, Spacer } from 'design-system';
import type React from 'react';
import { strings } from 'strings';

interface ClinicalSummaryCardProps {
  summary: ResourceNote;
}

export const ClinicalSummaryCard: React.FC<ClinicalSummaryCardProps> = ({
  summary,
}) => {
  const warningRow: RowConfig[] = [
    {
      icon: 'warning',
      fields: [
        {
          type: 'text',
          label: strings.ClinicalSummaryWarningLabel,
          display: strings.ClinicalSummaryWarningMessage,
        },
      ],
    },
  ];

  // Function to create structured content rows
  const createStructuredRows = (): RowConfig[] => {
    const rows: RowConfig[] = [];

    rows.push({
      icon: 'summarize',
      fields: [
        {
          type: 'text',
          label: strings.ClinicalSummaryLabel,
          display: (
            <MarkdownRenderer
              content={summary.text || ''}
              renderers={renderers}
            />
          ),
        },
      ],
    });
    return rows;
  };

  const clinicalSummaryRows = createStructuredRows();

  // Add the last updated timestamp
  const lastUpdatedRow: RowConfig = {
    fields: [
      {
        type: 'text',
        label: strings.ClinicalSummaryLastUpdated,
        display: getDisplayDateTime(summary.time),
      },
    ],
  };

  return (
    <>
      <FormCard
        cardColor="status-warning"
        showIcons={true}
        title={strings.PatientSearchWarningTitle}
        rows={warningRow}
      />
      <Spacer />
      <FormCard
        cardColor="base"
        showIcons={true}
        title={strings.ClinicalSummaryLabel}
        rows={[...clinicalSummaryRows, lastUpdatedRow]}
      />
    </>
  );
};
